const { getError } = require('../tools')

function shipsyFetch ({ logger, fetch, token, baseUrl, workspace }) {
  if (!baseUrl) throw new Error('Shipsy fetch: baseUrl is required')
  if (!workspace) throw new Error('Shipsy fetch: workspace is required')

  const fetcher = async ({ path, body, method }) => {
    if (!path) throw new Error('Shipsy fetch: path is required')
    const url = `${baseUrl}${path}`

    const headers = {
      'Content-Type': 'application/json',
      'Authorization': `Token ${token}`,
      'workspace': workspace
    }

    const payload = JSON.stringify(body)

    logger.info({ url, method, path, payload }, 'shipsy:request')

    const res = await fetch(url, {
      method,
      headers,
      body: payload
    })

    if (!res.ok) {
      const err = await getError(res)
      if (err) throw err
      return
    }

    return res
  }

  return fetcher
}

module.exports = shipsyFetch
